import { EditorObject } from 'utils/responsiveTypes'

const minimalListsGallery: EditorObject = {
  x: 290,
  y: 21,
  id: '3siafst7lw2u0yx37z4x9xp72',
  name: 'Gallery',
  type: 'LAYOUT_SECTION',
  width: 1222,
  height: 410,
  hidden: false,
  mobile: {
    x: 0,
    y: 21,
    width: 1512,
    height: 643,
    pushGraph: {
      edges: [],
      nodeIds: ['8go7acu37gyj9airocdl4ptts'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'LEFT_AND_RIGHT',
    },
  },
  shadow: {
    x: 0,
    y: 2,
    size: 4,
    color: '#00000020',
    enabled: true,
  },
  shared: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  tablet: {
    x: 0,
    y: 21,
    width: 1512,
    height: 644,
    pushGraph: {
      edges: [],
      nodeIds: ['8go7acu37gyj9airocdl4ptts'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'LEFT_AND_RIGHT',
    },
  },
  actions: {},
  desktop: {
    x: 0,
    y: 21,
    width: 1512,
    height: 637,
    pushGraph: {
      edges: [],
      nodeIds: ['8go7acu37gyj9airocdl4ptts'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'LEFT_AND_RIGHT',
    },
  },
  opacity: 1,
  children: [
    {
      x: 290,
      y: 59,
      id: '8go7acu37gyj9airocdl4ptts',
      name: 'Layout Helper',
      type: 'section',
      width: 1222,
      height: 334,
      hidden: false,
      mobile: {
        x: 0,
        y: 29,
        width: 1512,
        height: 627,
        pushGraph: {
          edges: [],
          nodeIds: ['14xphg89rmltdqbmi0rhbgfg0'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      shadow: {
        x: 0,
        y: 2,
        size: 4,
        color: 'rgba(0, 0, 0, 0.2)',
        enabled: false,
      },
      shared: {
        mobile: false,
        tablet: false,
        desktop: false,
      },
      tablet: {
        x: 0,
        y: 30,
        width: 1512,
        height: 626,
        pushGraph: {
          edges: [],
          nodeIds: ['14xphg89rmltdqbmi0rhbgfg0'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      actions: {},
      desktop: {
        x: 0,
        y: 29,
        width: 1512,
        height: 621,
        pushGraph: {
          edges: [],
          nodeIds: ['14xphg89rmltdqbmi0rhbgfg0'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      opacity: 1,
      purpose: 'layout_helper',
      children: [
        {
          x: 500.9999999999992,
          y: 59,
          id: '14xphg89rmltdqbmi0rhbgfg0',
          name: 'Container',
          type: 'section',
          width: 800,
          height: 334,
          hidden: false,
          mobile: {
            x: 62.03076923076923,
            y: 29,
            width: 1387.938461538462,
            height: 627,
            pushGraph: {
              edges: [],
              nodeIds: ['1bftbfoi435z6m2v6kb3mddpv'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          shadow: {
            x: 0,
            y: 2,
            size: 4,
            color: '#00000020',
            enabled: true,
          },
          shared: {
            mobile: false,
            tablet: false,
            desktop: false,
          },
          tablet: {
            x: 192.1726618705036,
            y: 30,
            width: 1127.6546762589928,
            height: 626,
            pushGraph: {
              edges: [],
              nodeIds: ['1bftbfoi435z6m2v6kb3mddpv'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          actions: {},
          desktop: {
            x: 261,
            y: 29,
            width: 989.9999999999998,
            height: 621,
            pushGraph: {
              edges: [],
              nodeIds: ['1bftbfoi435z6m2v6kb3mddpv'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          opacity: 1,
          purpose: 'container',
          children: [
            {
              x: 501.8080808080799,
              y: 70,
              id: '1bftbfoi435z6m2v6kb3mddpv',
              name: 'List 40',
              type: 'list',
              width: 798.3838383838386,
              height: 611,
              hidden: false,
              mobile: {
                x: 62.03076923076945,
                y: 40,
                width: 1387.938461538463,
                height: 611,
                pushGraph: {
                  edges: [],
                  nodeIds: ['boifnn5k68zi54v63yf55k16v'],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shared: {
                mobile: false,
                tablet: false,
                desktop: false,
              },
              tablet: {
                x: 193.985611510801,
                y: 42.5,
                width: 1124.0287769783981,
                height: 601,
                pushGraph: {
                  edges: [],
                  nodeIds: ['boifnn5k68zi54v63yf55k16v'],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              actions: {},
              desktop: {
                x: 262,
                y: 40,
                width: 987.9999999999997,
                height: 611,
                pushGraph: {
                  edges: [],
                  nodeIds: ['boifnn5k68zi54v63yf55k16v'],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              masonry: true,
              opacity: 1,
              children: [
                {
                  x: 501.8080808080799,
                  y: 70,
                  id: 'boifnn5k68zi54v63yf55k16v',
                  name: 'Rectangle 83',
                  type: 'section',
                  width: 184.59595959595964,
                  height: 186,
                  hidden: false,
                  mobile: {
                    x: 62.03076923076945,
                    y: 40,
                    width: 1387.938461538463,
                    height: 186,
                    pushGraph: {
                      edges: [
                        {
                          distance: 3,
                          endNodeId: '1b4xqjrd8ytpc9bbe9gbg2pi3',
                          startNodeId: '74rnkgygwlptcewijbyf0hbfo',
                        },
                      ],
                      nodeIds: [
                        '74rnkgygwlptcewijbyf0hbfo',
                        '1b4xqjrd8ytpc9bbe9gbg2pi3',
                      ],
                    },
                  },
                  shadow: {
                    x: 0,
                    y: 2,
                    size: 4,
                    color: 'rgba(0, 0, 0, 0.2)',
                    enabled: false,
                  },
                  tablet: {
                    x: 193.985611510801,
                    y: 42.5,
                    width: 552.0143884891991,
                    height: 186,
                    pushGraph: {
                      edges: [
                        {
                          distance: 3,
                          endNodeId: '1b4xqjrd8ytpc9bbe9gbg2pi3',
                          startNodeId: '74rnkgygwlptcewijbyf0hbfo',
                        },
                      ],
                      nodeIds: [
                        '74rnkgygwlptcewijbyf0hbfo',
                        '1b4xqjrd8ytpc9bbe9gbg2pi3',
                      ],
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 262,
                    y: 40,
                    width: 231.99999999999991,
                    height: 186,
                    pushGraph: {
                      edges: [
                        {
                          distance: 3,
                          endNodeId: '1b4xqjrd8ytpc9bbe9gbg2pi3',
                          startNodeId: '74rnkgygwlptcewijbyf0hbfo',
                        },
                      ],
                      nodeIds: [
                        '74rnkgygwlptcewijbyf0hbfo',
                        '1b4xqjrd8ytpc9bbe9gbg2pi3',
                      ],
                    },
                  },
                  opacity: 1,
                  children: [
                    {
                      x: 514.5051573940424,
                      y: 144,
                      id: '74rnkgygwlptcewijbyf0hbfo',
                      name: null,
                      text: 'ITEM TITLE',
                      type: 'label',
                      color: '@background',
                      width: 159.20180642402858,
                      height: 21,
                      hidden: false,
                      mobile: {
                        x: 157.49743589741354,
                        y: 114,
                        width: 1197.0051282051286,
                        height: 21,
                      },
                      shared: {
                        mobile: true,
                        tablet: true,
                        desktop: true,
                      },
                      tablet: {
                        x: 231.95485516348822,
                        y: 116.5,
                        width: 476.07590118380625,
                        height: 21,
                      },
                      actions: {},
                      desktop: {
                        x: 277.95767195766814,
                        y: 114,
                        width: 200.08465608465588,
                        height: 21,
                      },
                      opacity: 1,
                      children: [],
                      fontSize: 18,
                      autoWidth: false,
                      fontStyle: 'normal',
                      // maxLength: null,
                      multiline: false,
                      fontFamily: '@body',
                      // fontWeight: '700',
                      layoutText: ['ITEM TITLE'],
                      selectable: false,
                      positioning: 'fixed',
                      responsivity: {
                        verticalScaling: 'FIXED',
                        horizontalScaling: 'SCALES_WITH_PARENT',
                        verticalPositioning: 'TOP',
                        horizontalPositioning: 'CENTER',
                      },
                      initialDevice: 'desktop',
                      textAlignment: 'center',
                    },
                    {
                      x: 514.5051573940424,
                      y: 168,
                      id: '1b4xqjrd8ytpc9bbe9gbg2pi3',
                      name: null,
                      text: 'Subtitle',
                      type: 'label',
                      color: '@background',
                      width: 159.20180642402858,
                      height: 17,
                      hidden: false,
                      mobile: {
                        x: 157.49743589741354,
                        y: 138,
                        width: 1197.0051282051286,
                        height: 17,
                      },
                      shared: {
                        mobile: true,
                        tablet: true,
                        desktop: true,
                      },
                      tablet: {
                        x: 231.95485516348822,
                        y: 140.5,
                        width: 476.07590118380625,
                        height: 17,
                      },
                      actions: {},
                      desktop: {
                        x: 277.95767195766814,
                        y: 138,
                        width: 200.08465608465588,
                        height: 17,
                      },
                      opacity: 1,
                      children: [],
                      fontSize: 14,
                      autoWidth: false,
                      fontStyle: 'normal',
                      // maxLength: null,
                      multiline: false,
                      fontFamily: '@body',
                      // fontWeight: '400',
                      layoutText: ['Subtitle'],
                      selectable: false,
                      positioning: 'fixed',
                      responsivity: {
                        verticalScaling: 'FIXED',
                        horizontalScaling: 'SCALES_WITH_PARENT',
                        verticalPositioning: 'TOP',
                        horizontalPositioning: 'CENTER',
                      },
                      initialDevice: 'desktop',
                      textAlignment: 'center',
                    },
                  ],
                  pushGraph: {
                    edges: [
                      {
                        distance: 3,
                        endNodeId: '1b4xqjrd8ytpc9bbe9gbg2pi3',
                        startNodeId: '74rnkgygwlptcewijbyf0hbfo',
                      },
                    ],
                    nodeIds: [
                      '74rnkgygwlptcewijbyf0hbfo',
                      '1b4xqjrd8ytpc9bbe9gbg2pi3',
                    ],
                  },
                  borderColor: '#BDBDBD',
                  borderStyle: 'solid',
                  borderWidth: 2,
                  positioning: 'fixed',
                  borderRadius: 12,
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  borderPosition: 'center',
                  backgroundColor: '@primaryDark',
                  backgroundStyle: 'color',
                },
              ],
              listType: 'grid',
              pushGraph: {
                edges: [],
                nodeIds: ['boifnn5k68zi54v63yf55k16v'],
              },
              rowMargin: 20,
              columnCount: 4,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              deviceColumns: {
                mobile: {
                  listType: 'default',
                  rowMargin: 20,
                  columnCount: 1,
                },
                tablet: {
                  listType: 'grid',
                  rowMargin: 20,
                  columnCount: 2,
                },
                desktop: {
                  listType: 'grid',
                  rowMargin: 20,
                  columnCount: 4,
                },
              },
              initialDevice: 'desktop',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              columnBreakpoints: 'CUSTOM',
            },
          ],
          pushGraph: {
            edges: [],
            nodeIds: ['1bftbfoi435z6m2v6kb3mddpv'],
          },
          borderColor: '#e0e0e0',
          borderStyle: 'none',
          borderWidth: 1,
          positioning: 'fixedTop',
          borderRadius: 10,
          responsivity: {
            verticalScaling: 'FIXED',
            horizontalScaling: 'SCALES_WITH_PARENT',
            verticalPositioning: 'TOP',
            horizontalPositioning: 'CENTER',
          },
          initialDevice: 'desktop',
          borderPosition: 'center',
          backgroundColor: '#f5f5f5',
          backgroundStyle: 'none',
        },
      ],
      pushGraph: {
        edges: [],
        nodeIds: ['14xphg89rmltdqbmi0rhbgfg0'],
      },
      borderColor: '#BDBDBD',
      borderStyle: 'none',
      borderWidth: 1,
      positioning: 'fixed',
      borderRadius: 0,
      responsivity: {
        verticalScaling: 'FIXED',
        horizontalScaling: 'SCALES_WITH_PARENT',
        verticalPositioning: 'TOP',
        horizontalPositioning: 'CENTER',
      },
      initialDevice: 'desktop',
      borderPosition: 'center',
      backgroundColor: '#e0e0e0',
      backgroundStyle: 'none',
    },
  ],
  pushGraph: {
    edges: [],
    nodeIds: ['8go7acu37gyj9airocdl4ptts'],
  },
  borderColor: '#e0e0e0',
  borderStyle: 'none',
  borderWidth: 1,
  imageResize: 'cover',
  positioning: 'fixedTop',
  borderRadius: 0,
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'LEFT_AND_RIGHT',
  },
  initialDevice: 'desktop',
  snappingRules: {
    lock: {
      left: 0,
      right: 0,
    },
    snap: true,
    snapType: 'screenEdge',
  },
  borderPosition: 'center',
  backgroundColor: '@background',
  backgroundStyle: 'none',
}

export default minimalListsGallery
